var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '../button';
import Dropdown from '../dropdown';
import DropdownDivider from '../dropdown/divider';
import DropdownItem from '../dropdown/item';
import DropdownMenu from '../dropdown/menu';
// import Icon from '../icon'
import Label from '../label';
import { Styled } from './style';
export var AccountNavActions;
(function (AccountNavActions) {
    AccountNavActions["Logout"] = "logout";
    AccountNavActions["Settings"] = "settings";
})(AccountNavActions || (AccountNavActions = {}));
var AccountNav = /** @class */ (function (_super) {
    __extends(AccountNav, _super);
    function AccountNav(props) {
        var _this = _super.call(this, props) || this;
        _this.handleTeamClick = function (teamId) {
            if (_this.props.onItemClick) {
                _this.props.onItemClick(teamId);
            }
        };
        _this.handleItemClick = function (action) {
            if (_this.props.onItemClick) {
                _this.props.onItemClick(action);
            }
        };
        return _this;
    }
    AccountNav.prototype.render = function () {
        var _this = this;
        var trigger = (React.createElement("div", { className: "account-trigger" },
            React.createElement(Label, { circular: true }, this.props.name.charAt(0)),
            React.createElement("span", { className: "user" },
                React.createElement("span", { className: "name" }, this.props.name),
                this.props.teams.length > 1 && React.createElement("span", { className: "team" }, this.props.team))));
        var listTeams = this.props.teams.map(function (team) {
            if (_this.props.currentTeam === team.id) {
                return (React.createElement(DropdownItem, { selected: _this.props.currentTeam === team.id, key: team.id },
                    React.createElement(Button, { transparent: true }, team.name)));
            }
            else {
                return (React.createElement(DropdownItem, { key: team.id },
                    React.createElement(Button, { transparent: true, onClick: _this.handleTeamClick.bind(_this, { type: 'team', id: team.id, name: team.name }) }, team.name)));
            }
        });
        var divider = this.props.teams.length > 1 ? React.createElement(DropdownDivider, null) : '';
        return (React.createElement(Styled, { className: "account-nav", "data-qa": "account-nav" },
            React.createElement(Dropdown, { trigger: trigger },
                React.createElement(DropdownMenu, null,
                    React.createElement("span", { className: "team-list" }, this.props.teams.length > 1 && listTeams),
                    divider,
                    React.createElement(DropdownItem, null,
                        React.createElement(Button, { transparent: true, onClick: this.handleItemClick.bind(this, AccountNavActions.Settings) },
                            React.createElement(FormattedMessage, { id: "ui_component.account_nav.account_settings", defaultMessage: "Account Settings" }))),
                    React.createElement(DropdownItem, null,
                        React.createElement(Button, { transparent: true, onClick: this.handleItemClick.bind(this, AccountNavActions.Logout) },
                            React.createElement(FormattedMessage, { id: "ui_component.account_nav.logout", defaultMessage: "Logout" })))))));
    };
    AccountNav.propTypes = {
        name: PropTypes.string.isRequired,
        team: PropTypes.string.isRequired,
        teams: PropTypes.array,
    };
    return AccountNav;
}(React.Component));
export default AccountNav;
//# sourceMappingURL=index.js.map